import { FlowBaseUrlEnum } from '@constants/app.constants';
import {
  PassengerForm,
  PrimaryContactForm,
  TripDetailsPassengerForm,
} from '@models/form/form.models';
import { PassengerAssistanceUpdateRequest } from '@models/requests/passenger-update-request.model';
import { createAction, props } from '@ngrx/store';
import { Passenger, SeatMapAvailability } from 'src/app/models/booking.models';

export const enum PassengerActionTypes {
  validateSavePassengerAndContact = '[passenger] VALIDATE_SAVE_PASSENGER_AND_CONTACT',
  loadPassengerSpecialAssistanceSsrs = '[passenger] LOAD_PASSENGER_SPECIAL_ASSISTANCE_SSRS',
  setPassengerSpecialAssistanceSsrs = '[passenger] SET_PASSENGER_SPECIAL_ASSISTANCE_SSRS',
  updatePassengers = '[passenger] UPDATE_PASSENGERS',
  updatePassengersSuccess = '[passenger] UPDATE_PASSENGERS_SUCCESS',
  updateTripsPassengers = '[passenger] UPDATE_TRIPS_PASSENGERS',
  updateTripsPassengersSuccess = '[passenger] UPDATE_TRIPS_PASSENGERS_SUCCESS',
  updatePassengersAssistance = '[passenger] UPDATE_PASSENGERS_ASSISTANCE',
  updatePassengersAssistanceSuccess = '[passenger] UPDATE_PASSENGERS_ASSISTANCE_SUCCESS',
  UpdatePassengersDocumentsSuccess = '[passenger] UPDATE_PASSENGERS_DOCUMENTS',
  UpdatePrimaryContactSuccess = '[passenger] UPDATE_PRIMARY_CONTACT_SUCCESS',
  autoAssignSeats = '[passenger] AUTO_ASSIGN_SEATS',
}

export const passengerValidateSavePassengerAndContact = createAction(
  PassengerActionTypes.validateSavePassengerAndContact,
  props<{ payload: Passenger }>(),
);

export const passengerLoadSpecialAssistanceSsrs = createAction(
  PassengerActionTypes.loadPassengerSpecialAssistanceSsrs,
);

export const passengerSetSpecialAssistanceSsrs = createAction(
  PassengerActionTypes.setPassengerSpecialAssistanceSsrs,
  props<{ payload: Passenger }>(),
);

export const updateTripDetailsPassengers = createAction(
  PassengerActionTypes.updateTripsPassengers,
  props<{
    passengers: { [key: string]: TripDetailsPassengerForm };
  }>(),
);

export const updatePassengers = createAction(
  PassengerActionTypes.updatePassengers,
  props<{
    passengers: { [key: string]: PassengerForm };
    otherPassengerPrimaryContact?: PrimaryContactForm;
    redirectToPayment?: boolean;
    skipToPaymentModalDisplayed?: boolean;
  }>(),
);

export const updatePassengersSuccess = createAction(
  PassengerActionTypes.updatePassengersSuccess,
  props<{
    redirectToPayment?: boolean,
    flow?: FlowBaseUrlEnum,
  }>(),
);

export const autoAssignSeats = createAction(
  PassengerActionTypes.autoAssignSeats,
  props<{
    seatMaps: SeatMapAvailability[]
  }>(),
);

export const updateTripsPassengersSuccess = createAction(
  PassengerActionTypes.updateTripsPassengersSuccess,
);

export const updatePassengersAssistance = createAction(
  PassengerActionTypes.updatePassengersAssistance,
  props<{
    payload: PassengerAssistanceUpdateRequest[];
  }>(),
);

export const updatePassengersAssistanceSuccess = createAction(
  PassengerActionTypes.updatePassengersAssistanceSuccess,
);

export const updatePassengersDocumentsSuccess = createAction(
  PassengerActionTypes.UpdatePassengersDocumentsSuccess,
  props<{
    flow?: FlowBaseUrlEnum;
  }>(),
);

export const updatePrimaryContactSuccess = createAction(
  PassengerActionTypes.UpdatePrimaryContactSuccess,
);
